<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
.goback{
	position: absolute;
    z-index: 2;
    background: rgba(0,0,0,.3);
    color: #fff;
    font-size: .3rem;
    padding: .1rem .4rem;
    border-radius: 5px;
    top: .4rem;
    left: .4rem;
}
.el-input .el-input__inner{
    border:none !important;
    background-color: #f2f2f2;
    padding: 0 !important;
    font-size: .2rem;
    height: .6rem !important;
    line-height: .6rem;
    width:3rem;
  }
.el-input__prefix{
  display: none;
}
.el-input--prefix .el-input__inner{
  padding-left: 0;
}

.el-input--suffix .el-input__inner{
  padding-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue